import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Missing platform flags default to enabled; only explicit `false` hides a module (matches admin UI). */
export function normalizePlatformAccess(user) {
  const p = user?.platform_access || {};
  return {
    demaxtore: p.demaxtore !== false,
    commoditybid: p.commoditybid !== false,
    freightiq: p.freightiq !== false,
  };
}
